import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_HREF_LANG = 'x-default';
const DEFAULT_LANG_SET = [DEFAULT_HREF_LANG, 'en', 'de', 'es', 'fr', 'ja', 'pt'];

const HrefLangLink = ({
  href,
  lang,
  'x-default': defaultHrefLang
}) => {
  const hrefLang = lang || DEFAULT_HREF_LANG;
  return /*#__PURE__*/_jsx("link", {
    rel: "alternate",
    hrefLang: defaultHrefLang ? DEFAULT_HREF_LANG : hrefLang,
    href: href.replace(/\/$/, ''),
    "data-test-id": "href-lang-link"
  });
};

export default HrefLangLink;